import script from "./BubbleMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BubbleMenu.vue?vue&type=script&setup=true&lang=js"

import "./BubbleMenu.vue?vue&type=style&index=0&id=781b7ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781b7ec0"]])

export default __exports__